import { render, staticRenderFns } from "./welfareDaily.vue?vue&type=template&id=5677765e&scoped=true&"
import script from "./welfareDaily.vue?vue&type=script&lang=js&"
export * from "./welfareDaily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677765e",
  null
  
)

export default component.exports